import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// @ts-nocheck
import React, { useState } from "react";
import { gql, useQuery, useMutation } from "@apollo/client";
import { Box, Grid, TextField, List, ListItem, ListItemButton, ListItemText, IconButton, FormSnackBar, DeleteHandling, makeStyles, } from "../mui";
import { Edit, Check, BorderColorOutlined } from "@mui/icons-material";
import { getContent, ContentTypography } from "../common/content";
import Chat from "./Chat";
const useStyles = makeStyles((theme) => ({
    listItemButton: {
        cursor: "pointer",
        "&.Mui-selected": {
            borderRadius: 12,
            boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 24px 0px",
            color: theme.palette.primary[500],
            "& .MuiListItemIcon-root": {
                color: "white",
            },
        },
        "&.Mui-selected:hover": {
            borderRadius: 12,
            boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 24px 0px",
            color: theme.palette.primary[500],
            "& .MuiListItemIcon-root": {
                color: "white",
            },
        },
        "&:hover": {
            borderRadius: 12,
            boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 24px 0px",
            color: theme.palette.primary[500],
            "& .MuiListItemIcon-root": {
                color: "white",
            },
        },
    },
}));
const USER_CHATS = gql `
  query Chats {
    chats {
      id
      label
    }
  }
`;
const EDIT_CHAT = gql `
  mutation EditChat($id: ID!, $data: chatInput!) {
    editChat(id: $id, data: $data) {
      id
      label
    }
  }
`;
const REMOVE_CHAT = gql `
  mutation RemoveChat($id: ID!) {
    removeChat(id: $id) {
      success
    }
  }
`;
const Chats = ({ integrations = [] }) => {
    const classes = useStyles();
    const [selectedChat, setSelectedChat] = useState(null);
    const [chatLabel, setChatLabel] = useState({
        edit: false,
        id: null,
        label: "",
    });
    const [snackBar, setSnackBar] = React.useState({
        open: false,
        message: "",
        type: "",
    });
    const { loading, error, data } = useQuery(USER_CHATS);
    const [removeChat] = useMutation(REMOVE_CHAT, {
        refetchQueries: ["Chats"],
    });
    const [editChat] = useMutation(EDIT_CHAT);
    const resetChats = () => {
        setChatLabel({
            edit: false,
            id: null,
            label: "",
        });
        setSelectedChat(null);
    };
    return (_jsxs(_Fragment, { children: [_jsx(FormSnackBar, { snackBar: snackBar, setSnackBar: setSnackBar }), _jsxs(Grid, { container: true, children: [_jsx(Grid, { item: true, xs: 12, sm: 2, children: _jsxs(List, { children: [_jsx(ListItem, { children: _jsx(ListItemButton, { onClick: resetChats, selected: selectedChat === null, className: classes.listItemButton, children: _jsxs(Box, { sx: {
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                width: "100%",
                                            }, children: [_jsx(ContentTypography, { color: selectedChat ? "secondary" : "primary", variant: "subtitle2", field: "newChatLabel" }), _jsx(BorderColorOutlined, { sx: { fontSize: 18, ml: 1 }, color: selectedChat ? "secondary" : "primary" })] }) }) }), data?.chats?.map((chat, index) => (_jsx(ListItem, { children: _jsxs(ListItemButton, { className: classes.listItemButton, onClick: () => setSelectedChat(chat?.id), selected: selectedChat === chat?.id, sx: {
                                            display: "flex",
                                            justifyContent: "space-between",
                                            "&:hover": {
                                                backgroundColor: "#f1f1f1",
                                                ".action-icons": {
                                                    opacity: 1,
                                                },
                                            },
                                        }, children: [chatLabel?.edit === true && chatLabel?.id === chat?.id ? (_jsx(TextField, { fullWidth: true, variant: "standard", value: chatLabel?.label || "", onChange: (e) => setChatLabel({
                                                    ...chatLabel,
                                                    label: e?.target?.value,
                                                }), onKeyDown: (e) => {
                                                    if (e.key === "Enter")
                                                        handleSubmit();
                                                } })) : (_jsx(ListItemText, { primary: chat?.label, primaryTypographyProps: {
                                                    color: selectedChat === chat?.id ? "primary" : "secondary",
                                                    fontWeight: selectedChat === chat?.id ? "bold" : "regular",
                                                } })), _jsxs(Box, { className: "action-icons", sx: {
                                                    display: "flex",
                                                    gap: 0.5,
                                                    opacity: 0,
                                                    transition: "opacity 0.2s",
                                                }, children: [chatLabel?.edit === true && chatLabel?.id === chat?.id ? (_jsx(IconButton, { edge: "end", size: "small", onClick: (e) => {
                                                            e.stopPropagation();
                                                            editChat({
                                                                variables: {
                                                                    id: chatLabel?.id,
                                                                    data: {
                                                                        label: chatLabel?.label,
                                                                    },
                                                                },
                                                                onCompleted: () => {
                                                                    setChatLabel({
                                                                        edit: false,
                                                                        id: null,
                                                                        label: "",
                                                                    });
                                                                },
                                                                onError: () => setChatLabel({
                                                                    edit: false,
                                                                    id: null,
                                                                    label: "",
                                                                }),
                                                            });
                                                        }, children: _jsx(Check, { fontSize: "small" }) })) : (_jsx(IconButton, { edge: "end", size: "small", onClick: (e) => {
                                                            e.stopPropagation();
                                                            setChatLabel({
                                                                edit: true,
                                                                id: chat?.id,
                                                                label: chat?.label,
                                                            });
                                                        }, children: _jsx(Edit, { fontSize: "small" }) })), _jsx(DeleteHandling, { onDelete: (e) => {
                                                            e.stopPropagation();
                                                            removeChat({
                                                                variables: { id: chat?.id },
                                                                onCompleted: () => {
                                                                    setSnackBar({
                                                                        open: true,
                                                                        message: `${chat?.label} ${getContent("removedSuccessMessage")}`,
                                                                        type: "info",
                                                                    });
                                                                    resetChats();
                                                                },
                                                                onError: () => setSnackBar({
                                                                    open: true,
                                                                    message: `${getContent("errorMessage")}`,
                                                                    type: "error",
                                                                }),
                                                            });
                                                        }, mobileOnly: true })] })] }) }, index)))] }) }), _jsx(Grid, { item: true, xs: 10, xs: 12, sm: 10, children: _jsx(Chat, { chatId: selectedChat, integrations: integrations }) })] })] }));
};
export default Chats;
